import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Home from './pages/home';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PanoContextContainer from './contexts/PanoContextContainer.js';
import PageTransition from './pages/components/pageTransition';

/** Set to true to show document meta (title, meta tags, manifest) in the browser for debugging. */
const SHOW_DEBUG_META = false;

function getDocumentMeta() {
  const title = document.title || '';
  const metaList = [];
  const metas = document.querySelectorAll('head meta');
  metas.forEach((el) => {
    const name = el.getAttribute('name') || el.getAttribute('property');
    const content = el.getAttribute('content');
    if (name && content) metaList.push({ name, content });
  });
  const links = [];
  document.querySelectorAll('head link[rel="manifest"]').forEach((el) => {
    links.push({ rel: 'manifest', href: el.getAttribute('href') });
  });
  return { title, metaList, links };
}

function DebugMetaPanel() {
  const [meta, setMeta] = useState(null);
  const [manifest, setManifest] = useState(null);
  useEffect(() => {
    setMeta(getDocumentMeta());
    fetch(`${process.env.PUBLIC_URL || ''}/manifest.json`)
      .then((r) => r.json())
      .then(setManifest)
      .catch(() => setManifest({ error: 'Failed to load' }));
  }, []);
  if (!meta) return null;
  return (
    <div className="debug-meta-panel" aria-hidden="true">
      <div className="debug-meta-panel__title">Document meta (debug)</div>
      <div className="debug-meta-panel__row"><strong>title</strong> {meta.title}</div>
      {meta.metaList.map((m, i) => (
        <div key={i} className="debug-meta-panel__row"><strong>{m.name}</strong> {m.content}</div>
      ))}
      {meta.links.length > 0 && meta.links.map((l, i) => (
        <div key={`link-${i}`} className="debug-meta-panel__row"><strong>{l.rel}</strong> {l.href}</div>
      ))}
      {manifest && (
        <>
          <div className="debug-meta-panel__title">manifest.json</div>
          {manifest.error ? (
            <div className="debug-meta-panel__row">{manifest.error}</div>
          ) : (
            <pre className="debug-meta-panel__pre">{JSON.stringify(manifest, null, 2)}</pre>
          )}
        </>
      )}
    </div>
  );
}

function App() {
  const location = useLocation();
  return (
    <>
      {SHOW_DEBUG_META && <DebugMetaPanel />}
      <PageTransition>
        <Switch location={location}>
          <Route
            exact
            path="/"
            render={() => {
              return (
                <Redirect to="/index" />  
              )
            }}
          />
          <Route exact path="/index" render={() => {
            return (
              <PanoContextContainer>
                <Home />
              </PanoContextContainer>
            )
          }} />
        </Switch>
      </PageTransition>
    </>
  );
}

const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;
